// DEPENDENCIES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGInline from 'react-svg-inline';

// utils
// import { isMobile } from '../../utils';

// inner imports
import { BAND, MUSICIAN } from '../../consts';

// svgs
import caretDropFullSVG from '../inlineSVGs/caretDropFullSVG';


// style imports
import './DropdownMobileFilterBar.css';

class DropdownMobileFilterBar extends Component {
    constructor() {
        super();
        this.state = {
            isDropdownOpen: false,
            orderedOptions: []
        }
    }
    // Enables ordering the array where the selected option is first
    moveElementToBeFirst(array, value) { // Get the array and the value of the option you want to be first
        const oldIndex = array.indexOf(value);
        const newIndex = 0; // We want to put the value FIRST
        if (oldIndex > -1){ // Checking if the value exists in the array
            const arrayClone = array.slice();
            arrayClone.splice(oldIndex,1);
            arrayClone.splice(newIndex,0,value);

            return arrayClone;
        }
        return array;
    }
    // Order the options, find the selected one and then calling moveElementToBeFirst so the selected would be first
    orderOptions(options, selected) {
        //let orderedOptions = options;
        // this.props.options.forEach((option)=>{
        //     if (option.name===selected) {
        //         orderedOptions = this.moveElementToBeFirst(this.props.options, option);
        //     }
        // });
        this.setState({
            orderedOptions: options
        })
    }
    // Call orderOptions right after the component is ready
    componentDidMount() {
        this.orderOptions(this.props.options, this.props.selected)
    }
    // Call orderOptions right after the props are changed
    componentWillReceiveProps(nextProps) {
        // call orderOptions only if the selected value has changed
        if (nextProps.selected !== this.props.selected) {
            this.orderOptions(nextProps.options, nextProps.selected)
        }
    }

    clickedDropdown() {
        this.setState({isDropdownOpen: !this.state.isDropdownOpen});
    }

    getSelectedType() {
        if (!this.state.orderedOptions) return {};
        return this.state.orderedOptions.find(o => o.name === this.props.selected);
    }

    handleClickOption(event, option) {
        this.props.onChange(option.name);
        event.stopPropagation();
        setTimeout(() => {
            this.setState({isDropdownOpen: false})
        }, 100);
    }

    // not in use in the new design - leaving this for now
    renderNewLabel(name) {
        if (name !== BAND && name !== MUSICIAN) return;

        return (
            <div className="new-label"><p>New</p></div>
        )
    }

    renderOrderedOptions(selectedTypeName) {
        return this.state.orderedOptions.map((option, index) => {
            if (!this.state.isDropdownOpen) return null;
            return (
                <div key={index}
                     className={`option ${option.name} ${selectedTypeName === option.name ? 'selected' : ''}`}
                     onClick={e => this.handleClickOption(e, option)}
                >
                    {option.text}
                </div>
            );
        })
    }

    render() {
        if (!this.props) return null;

        const selectedType = this.getSelectedType() || {};

        return (
            <div className={`dropdown ${selectedType.name} ${this.state.isDropdownOpen ? 'open' : ''}`} onClick={this.clickedDropdown.bind(this)}>
                <div className={"firstOption " + selectedType.name}  >
                    <SVGInline className="caret-full-icon" svg={caretDropFullSVG} component="i"/>

                    {selectedType.text}
                </div>
                {this.renderOrderedOptions(selectedType.name)}
            </div>
        )
    }
}

DropdownMobileFilterBar.propTypes = {
    selected: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    onChange: PropTypes.func,
    options: PropTypes.array
};

export default DropdownMobileFilterBar;



// WEBPACK FOOTER //
// ./src/Components/Main/DropdownMobileFilterBar.js